import { Input, Text, Button } from '@fragments';
import { CloseRounded, WebhookRounded } from '@mui/icons-material';
import { ACTION_TYPES_BY_PLATFORM } from '../../../enums/actionTypes';
import './styles.scss';

export default function ActionCard({ action, platform, onRemove, onUpdate, index }) {
    const typeOptions = ACTION_TYPES_BY_PLATFORM[platform] ?? [
        { value: 'webhook_call', label: 'Chamada de Webhook' },
    ];
    const isTypeLocked = typeOptions.length === 1;

    function handleTypeChange(val) {
        onUpdate({ type: val, config: { webhook_url: '' } });
    }

    function handleUrlChange(val) {
        onUpdate({ config: { ...action.config, webhook_url: val } });
    }

    return (
        <div className="manage-action-card">
            <div className="manage-action-card__header">
                <Text.span contrast={8} weight={400}>
                    Tipo:
                </Text.span>

                <div className="manage-action-card__type-select">
                    <Input.Select
                        value={action.type}
                        onInput={handleTypeChange}
                        options={typeOptions}
                        disabled={isTypeLocked}
                        placeholder="Selecionar tipo de ação"
                    />
                </div>

                <Button
                    onClick={onRemove}
                    icon={<CloseRounded fontSize="small" />}
                    color="overlay"
                    size="small"
                    tooltip="Remover ação"
                />
            </div>

            {action.type === 'webhook_call' && (
                <div className="manage-action-card__body">
                    <Input.Text
                        label="URL de Webhook"
                        placeholder="Insira o endereço de webhook"
                        value={action.config?.webhook_url ?? ''}
                        onInput={handleUrlChange}
                        start={<WebhookRounded fontSize="small" />}
                    />
                </div>
            )}
        </div>
    );
}
